var _defs, _circle, _g, _circle2, _g2, _polygon, _path, _polygon2, _polygon3, _polygon4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 744.83 193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#7bd3bd;stroke-miterlimit:10;stroke-width:6px;}.cls-3{clip-path:url(#clip-path);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:#7bd3bd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "75 75 123 9.5 172 63.5 163 112.5 123 140.5 75 75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "236 118 188 52.5 139 106.5 148 155.5 188 183.5 236 118"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 75,
    cy: 75,
    r: 8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 75,
    cy: 75,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 75,
    cy: 75,
    r: 72
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 236,
    cy: 118,
    r: 8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 236,
    cy: 118,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 236,
    cy: 118,
    r: 72
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "284 51 284 142.96 300.83 142.96 356.11 51 339.51 51 298 122 298 51 284 51"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M429,97a32.5,32.5,0,1,1-32.5-32.5A32.5,32.5,0,0,1,429,97ZM396.5,48.5A48.5,48.5,0,1,0,445,97,48.49,48.49,0,0,0,396.5,48.5Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "455.38 51 455.38 142.96 502.36 142.96 502.36 129.5 468.83 129.5 468.83 51 455.38 51"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "528.19 90.49 560.36 51 578.36 51 540.91 96.5 579.91 143.5 560.4 143 532.91 106.5 528.19 111.78 527.47 142.96 514.19 142.96 514.19 51 527.89 50.99 528.19 90.49"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "690.7 143.5 676.4 143.5 676.4 51 690.7 51 731.5 117.5 731.5 51 744.83 50.99 744.83 143.5 731.43 143.5 690.5 76.5 690.7 143.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M585.91,143.5,644.79,51h16.34v92H647.21V121.5h-31.3L602.79,143Zm39.5-36.5,22,.35V72Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dfef4a04eda2b71b1496037549177a45.svg";
export { ForwardRef as ReactComponent };